import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController, ToastController } from '@ionic/angular';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import _ from 'lodash';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { first } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.page.html',
  styleUrls: ['./comment-modal.page.scss'],
  standalone: false,
})
export class CommentModalPage implements OnInit {
  @Input() customer_id: any;
  @Input() post_id: any;
  public settings: any;
  private appSettingsSubscription: Subscription;
  loading: boolean = false;
  commentForm: FormGroup;
  constructor(private formBuilder: FormBuilder, public modalCtrl: ModalController, private toastCtrl: ToastController, private translate: TranslateService, private apiService: ApiService) {
    this.commentForm = this.formBuilder.group({
      post_id: new FormControl(this.post_id, Validators.compose([Validators.required])),
      customer_id: new FormControl(this.customer_id, Validators.compose([Validators.required])),
      content: new FormControl('', Validators.compose([Validators.required, Validators.minLength(1)])),
    });
  }
  ngOnInit() {}
  onSubmit = () => {
    this.loading = true;

    this.apiService
      .post(endpoints.comments, this.commentForm.value)
      .pipe(first())
      .subscribe(
        async (response) => {
          this.loading = false;
          //this.hideLoading();

          if (response.success) {
            this.modalCtrl.dismiss({ status: true, content: this.commentForm.value.content }, 'cancel');
          } else {
            this.modalCtrl.dismiss(false, 'cancel');
          }
          this.toastMessage(response.message);
        },
        (err) => {
          this.modalCtrl.dismiss(false, 'cancel');
        },
      );
  };
  closeModal = () => {
    this.modalCtrl.dismiss(false, 'cancel');
  };
  toastMessage = async (msg) => {
    await this.toastCtrl
      .create({
        message: this.translate.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'primary',
      })
      .then((toastElem) => toastElem.present());
  };
}
